import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/arrow-left-eoi-request.svg'


const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "customer__container"
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "details-block details-block--buyer" }
const _hoisted_5 = { class: "details-row details-row--adaptive" }
const _hoisted_6 = { class: "details-value" }
const _hoisted_7 = { class: "details-row details-row--adaptive" }
const _hoisted_8 = { class: "details-value" }
const _hoisted_9 = { class: "details-row details-row--adaptive" }
const _hoisted_10 = { class: "details-value" }
const _hoisted_11 = { class: "details-row details-row--adaptive" }
const _hoisted_12 = { class: "details-value" }
const _hoisted_13 = { class: "details-row details-row--adaptive" }
const _hoisted_14 = { class: "details-value" }
const _hoisted_15 = { class: "preference-block" }
const _hoisted_16 = { class: "preference-block" }
const _hoisted_17 = { class: "preference-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isFetching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (Object.keys($setup.form).length && !$setup.isFetching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", {
            class: "customer__title",
            onClick: $setup.onBack
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
            _createElementVNode("span", null, _toDisplayString($setup.form.estate.title), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("form", {
              class: "login-form",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "button primary button-my-profile medium",
                  onClick: $setup.onMyProfile
                }, "My Profile"),
                _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "details-block-title" }, "Buyer details", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "details-label" }, "First name", -1)),
                  _createElementVNode("div", _hoisted_6, _toDisplayString($setup.form.buyer.firstName), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "details-label" }, "Last name", -1)),
                  _createElementVNode("div", _hoisted_8, _toDisplayString($setup.form.buyer.lastName), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "details-label" }, "Email", -1)),
                  _createElementVNode("div", _hoisted_10, _toDisplayString($setup.form.buyer.email), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "details-label" }, "Phone number", -1)),
                  _createElementVNode("div", _hoisted_12, _toDisplayString($setup.form.buyer.phone), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "details-label" }, "Postcode", -1)),
                  _createElementVNode("div", _hoisted_14, _toDisplayString($setup.form.buyer.postcode? $setup.form.buyer.postcode
: $setup.form.buyer.state), 1)
                ])
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "details-block-title" }, "Lot preferences", -1)),
              _createElementVNode("div", _hoisted_15, [
                _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "details-block-sub-title" }, "Lot size:", -1)),
                _createVNode($setup["SliderLimited"], {
                  modelValue: $setup.form.lot.size,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.lot.size) = $event)),
                  minTitle: "Min size",
                  minValue: $setup.ranges.size?.min || 0,
                  maxTitle: "Max size",
                  maxValue: $setup.ranges.size?.max || 10000000,
                  position: "right",
                  units: "m²",
                  step: 10
                }, null, 8, ["modelValue", "minValue", "maxValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "details-block-sub-title" }, "Frontage (width):", -1)),
                _createVNode($setup["SliderLimited"], {
                  modelValue: $setup.form.lot.frontage,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.lot.frontage) = $event)),
                  minTitle: "Min size",
                  minValue: $setup.ranges.frontage?.min || 0,
                  maxTitle: "Max size",
                  maxValue: $setup.ranges.frontage?.max || 10000000,
                  position: "right",
                  units: "m",
                  step: 1
                }, null, 8, ["modelValue", "minValue", "maxValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "details-block-sub-title" }, "Budget:", -1)),
                _createVNode($setup["SliderLimited"], {
                  modelValue: $setup.form.lot.budget,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.lot.budget) = $event)),
                  minTitle: "Min size",
                  minValue: $setup.ranges.budget?.min || 0,
                  maxTitle: "Max size",
                  maxValue: $setup.ranges.budget?.max || 10000000,
                  position: "left",
                  units: "$",
                  step: 10000
                }, null, 8, ["modelValue", "minValue", "maxValue"])
              ]),
              _createElementVNode("div", { class: "form-group-controls" }, [
                _createElementVNode("button", {
                  class: "button primary",
                  onClick: $setup.onSave
                }, "Save"),
                _createElementVNode("button", {
                  class: "button",
                  onClick: $setup.onCancel
                }, "Cancel")
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}